import { z } from 'zod';

import { CompanyId, EventId } from '../BrandedIds';
import { CompanyReportType } from '../CompanyReport';
import { zodBrandedUuid } from '../utils';
import { BaseLoanIdSideEffect } from './BaseLoanIdSideEffect';

export const UpsertInvestorReportingSideEffectContext = BaseLoanIdSideEffect.extend({
  reportType: z.enum([CompanyReportType.FREDDIE_MAC_LLR_DAILY, CompanyReportType.FANNIE_MAE_LAR_96_DAILY]),
  eventId: zodBrandedUuid<EventId>(),
  companyId: zodBrandedUuid<CompanyId>(),
});

export const UpsertInvestorReportingSideEffect = UpsertInvestorReportingSideEffectContext.extend({
  type: z.literal('upsertInvestorReporting'),
});
export type UpsertInvestorReportingSideEffect = z.infer<typeof UpsertInvestorReportingSideEffect>;
